import { DefaultPrimaryHeader, HeaderBlock, VulnerabilityEntitySecondary } from '../activityFeedHeaderShared';

function VulnerabilityEntityHeader({ entity, item, activity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity?.cve} activity={activity} linkProps={linkProps} />}
      secondary={<VulnerabilityEntitySecondary entityMeta={entity.entity} item={item} />}
    />
  );
}

export default VulnerabilityEntityHeader;
